import { CarouselItem } from '@browsing/get-inspired';
import { SHOWSTOPPER_FIXED_POSITION } from '@client/config/constants';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { Campaign, Showstopper } from '@shared/types/mylounge';

export interface ShowstopperMedia {
    type: string;
    desktop: string;
    mobile: string;
}
export interface ShowstopperContent {
    title: string;
    content: string;
    campaigns: CarouselItem[];
    position?: number;
    media: ShowstopperMedia;
    categoryTabId: string;
    visitorID?: string;
}

const pick1x1Image = (campaign: Campaign) => {
    const validImages = campaign.images.campaigns.filter(x => x.aspectRatio === '1x1');
    return validImages.length > 0 ? validImages[0].url : campaign.images.mobile;
};

export const buildShowstopperContent: (
    showstopper: Showstopper,
    openCampaigns: Campaign[],
    categoryTabId: string,
    visitorID?: string,
) => ShowstopperContent = (
    showstopper: Showstopper,
    openCampaigns: Campaign[],
    categoryTabId: string,
    visitorID?: string,
) => {
    if (!showstopper) {
        return undefined;
    }
    const showstopperCampaigns = openCampaigns.filter((campaign: Campaign) =>
        campaign.showstopperIds.includes(showstopper?.id),
    );
    const showstopperCarouselCampaigns = showstopperCampaigns.map((campaign: Campaign) => ({
        sku: campaign.campaignId,
        brand: campaign.name,
        commodityGroup: '',
        discount: campaign.discount?.maxDiscount,
        images: pick1x1Image(campaign),
        url: buildCampaignUrl(campaign.campaignId),
        dateTill: Date.parse(campaign.endsAt),
        isEarlyAccess: campaign.plusEarlyAccess,
    }));

    return {
        title: showstopper.title,
        content: showstopper.content,
        campaigns: showstopperCarouselCampaigns,
        media: {
            type: 'IMAGE',
            desktop: showstopper.image,
            mobile: showstopper.image,
        },
        position: SHOWSTOPPER_FIXED_POSITION,
        categoryTabId,
        visitorID,
    };
};
